import { createReducer } from 'services/reduxHelpers'
import { priceTypes } from 'reduxModules/actions/PriceActions'

/* ------------- Initial State ------------- */

export const initialState = {
  prices: [],
  citiesRoutePrice: {}
}

/* ------------- Hookup Reducers To Types ------------- */

export default createReducer(initialState, {
  [priceTypes.GET_PRICES_SUCCESS]: (_, { data }) => ({ 
    prices: data
  }),

  [priceTypes.CLEAR_PRICES_ATTEMPT]: () => ({
    prices: []
  }),

  [priceTypes.GET_CITIES_ROUTE_PRICE_SUCCESS]: (_, { data }) => ({ 
    citiesRoutePrice: data
  }),

  [priceTypes.CLEAR_CITIES_ROUTE_PRICE_ATTEMPT]: () => ({
    citiesRoutePrice: {}
  }),

  [priceTypes.CHANGE_PRICE_ATTEMPT]: ({ prices }, { data: { id, value } }) => ({
    prices: prices.map(price => {
      if (price.id === id) {
        return {
          ...price,
          price: value,
        }
      }

      return price
    })
  })
})



// WEBPACK FOOTER //
// ./src/reduxModules/reducers/PriceReducer.js